import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Setup from "./pages/Setup";
import Preview from "./pages/Preview";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Assessment from "./pages/Assessment";
import Companion from "./pages/Companion";
import Compatibility from "./pages/Compatibility";
import Community from "./pages/Community";
import Journal from "./pages/Journal";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PublicBlueprint from "./pages/PublicBlueprint";
import AdminAI from "./pages/AdminAI";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-sm">aligning the stars…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Inner() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/preview" element={<Preview />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/blueprint/:token" element={<PublicBlueprint />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/assessment" element={<Protected><Assessment /></Protected>} />
      <Route path="/companion" element={<Protected><Companion /></Protected>} />
      <Route path="/journal" element={<Protected><Journal /></Protected>} />
      <Route path="/compatibility" element={<Protected><Compatibility /></Protected>} />
      <Route path="/community" element={<Protected><Community /></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="/admin/ai" element={<Protected><AdminAI /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Inner />
    </BrowserRouter>
  );
}
